<div *ngIf="quarterForm != null" class="row" [formGroup]="quarterForm">
  <div class="col-12">
    <div class="w-100 d-flex justify-content-between">
      <div>
        <span class="me-3">Year/Quarter</span>
        <lib-quarter-picker
          [minimumValue]="minimumValue"
          [maximumValue]="maximumValue"
          formControlName="chosenQuarter"></lib-quarter-picker>
      </div>
      <button (click)="download()" class="btn btn-primary" [disabled]="chosen == null">
        Download Selected
      </button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <lib-report-selector
      (selectedReports)="selectionChanged($event)"
      *ngIf="reports.length > 0 && !loadingReports; else elseBlock"
      [reports]="reports">
    </lib-report-selector>
    <ng-template #elseBlock>No reports available for this quarter.</ng-template>
  </div>
</div>
